import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {QuotationRecord} from "../api";

export class QuotationRecordService extends RestService<QuotationRecord> {
    constructor(url) {
        url ? super(url) : super(REST_API_END_POINTS.QUOTATION_RECORD)
    }
}
